import { render } from "./AsetGudang.vue?vue&type=template&id=b61b47fc"
import script from "./AsetGudang.vue?vue&type=script&lang=js"
export * from "./AsetGudang.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__